import { render, staticRenderFns } from "./Detail-Leave.vue?vue&type=template&id=22e1b98e&scoped=true"
import script from "./Detail-Leave.vue?vue&type=script&lang=js"
export * from "./Detail-Leave.vue?vue&type=script&lang=js"
import style0 from "./Detail-Leave.vue?vue&type=style&index=0&id=22e1b98e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e1b98e",
  null
  
)

export default component.exports